<template>
  <div class="avatar-selector">
    <div>
      <app-error-dialog @dismissed="onDismissed" :title='title' :message='message' :dialog='dialog'></app-error-dialog>
    </div>
    <v-row>
      <Avatar v-if="!noPreview" :value="value" :url="url" :previewSize="previewSize" :tile="tile" :icon="icon" style="z-index: 0; position: relative;"></Avatar>
      <image-uploader
        :preview="false"
        :className="['fileinput', { 'fileinput--loaded': hasImage }]"
        capture="environment"
        :debug="1"
        doNotResize="gif"
        :autoRotate="true"
        outputFormat="blob"
        @input="setImage"
        :enable="enable"
        :noPreview="noPreview"
        :style="noPreview ? 'margin-right: 12px;' : 'z-index: 1; position: absolute; '"
        :previewSize="previewSize"
      ></image-uploader>
    </v-row>

  </div>
</template>

<script>
import Vue from 'vue'
import _ from 'lodash'
import Avatar from './Avatar.vue'
import ImageUploader from './ImageUploader.vue'
import ErrorDialogCmp from '../ErrorDialog.vue'
Vue.component('app-error-dialog', ErrorDialogCmp)

export default {
  name: 'AvatarSelector',
  props: {
    url: String,
    value: Blob,
    enable: Boolean,
    previewSize: Number,
    tile: Boolean,
    icon: String,
    noPreview: Boolean
  },
  data () {
    return {
      dialog: false,
      title: 'Error',
      message: 'message',
      hasImage: false,
      image: null,
      formats: ['image/jpg', 'image/jpeg', 'image/png'],
      size: 5000
    }
  },
  computed: {
    formatsString: {
      get () {
        return this.formats ? _.join(this.formats, ', ') : '*'
      }
    }
  },
  components: {
    Avatar,
    ImageUploader
  },
  methods: {
    setImage (output) {
      this.hasImage = true
      this.image = output
      if (output && this.beforeAvatarUpload(output)) {
        this.$emit('input', output)
      } else {
        this.$emit('input', null)
      }
    },
    getSize () {
      return 'z-index: 1; position: absolute; left: ' + String(this.previewSize / 2) + 'px'
    },
    beforeAvatarUpload (file) {
      const isformatValid =
        _.findIndex(this.formats, f => f === file.type) >= 0
      const isSizeValid = (file.size / 1024) < this.size
      if (!isformatValid) {
        this.message = 'Avatar picture has invalid format!'
        this.dialog = true
      }
      if (!isSizeValid) {
        this.message = 'Avatar picture has invalid size!'
        this.dialog = true
      }
      return isformatValid && isSizeValid
    },
    onDismissed () {
      this.dialog = false
    }
  }
}
</script>

<style lang="scss" scoped>

input[type="file"] {
  display: none;
}

input[type="button"] {
  border: 1px solid grey;
}

.avatar-selector {
  align-items: center;
  display: flex;
  .avatar-instructions {
    font-style: italic;
    margin: 10px;
  }
}

</style>
